import { Injectable } from "@angular/core";
import { VitalRangeModel } from "@core/models/vitalRangeModel";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { VitalsRangeAction } from "./vitalsRange.action";



export class VitalsRangeModel {
  vitalsRange: VitalRangeModel[]
}

@State<VitalsRangeModel>({
  name: 'VitalsRangeState',
  defaults: {
    vitalsRange: []
  }
})

@Injectable()

export class VitalsRangeState {
  constructor() {}

  @Selector()
  static getVitalsRange(state: VitalsRangeModel) {
    return state.vitalsRange;
  }

  @Action(VitalsRangeAction)
  VitalsRangeAction({getState, patchState}: StateContext<VitalsRangeModel>, {payload}: VitalsRangeAction) {
    const state = getState();
    patchState({
      vitalsRange: payload
    });
  }
}